import { FacilityAddress } from "@/types/facility"
import { cleanDeep } from "@/utils/index"

export const isEditingAnotherRow = (
   activeRowId: string,
   currentRowid: string
) => {
   return activeRowId !== "" && activeRowId !== currentRowid
}

// `cleanDeep` drops nulls, but a null timezone means "device default" and the
// PATCH must send it explicitly, or the backend keeps the previous timezone.
export const buildAddressPayload = (
   address: FacilityAddress
): FacilityAddress => ({
   ...(cleanDeep(address) as FacilityAddress),
   timezone: address.timezone,
})
